import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { MiscService, VisitorMeasureService } from '@services/index';

declare var swal: any;

@Component({
    selector: 'app-util-visitor-parts-measure-list',
    templateUrl: './list.component.html',
})
export class UtilVisitorPartsMeasureListComponent implements OnInit {
    @Input() visitor: any = null;
    @Output() updateEvent = new EventEmitter();

    isLoading = true;
    isLoadingVisitors = false;
    selfVisitor = false;
    filter: any = {
        date_begin: null,
        date_end: null
    };
    limit = 20;
    page = 1;
    visitorMeasures: any;
    hasData = {
        visitorMeasures: false
    };

    constructor(private cdref: ChangeDetectorRef,
                private miscService: MiscService,
                private visitorMeasureService: VisitorMeasureService) {}

    ngOnInit() {
        this.miscService.can("getVisitorMeasure");
        this.isLoading = true;
        this.selfVisitor = this.miscService.checkDataLength(this.visitor) ? true : false;
        this.getVisitorsMeasures();
        this.cdref.detectChanges();
    }

    filterVisitorMeasures(filter = null) {
        this.filter = filter;
        this.getVisitorsMeasures(true);
    }

    getVisitorsMeasures(hasFilter = false) {
        this.isLoading = true;
        let data = this.filter;
        data.visitor_ids = this.selfVisitor ? [this.visitor.id] : (data.visitor_ids && data.visitor_ids.length ? data.visitor_ids : null);
        data.limit = this.limit;
        data.page = !hasFilter ? this.page : 1;     // if user has filtered, then reset page to 1 (number of pages can change due to filters)
        this.visitorMeasureService.getByVisitors(data).subscribe(data => {
            this.visitorMeasures = data;
            this.hasData.visitorMeasures = this.miscService.checkDataLength(this.visitorMeasures.data);
            this.isLoading = false;
        }, error => {
            this.visitorMeasures = null;
            this.hasData.visitorMeasures = false;
            this.miscService.showMsg({ msg: "VISITOR_MEASURES_NOT_FOUND_PLEASE_CHECK_FILTERS" });
            this.isLoading = false;
        });
    }
    
    addMeasure() {
        this.getVisitorsMeasures();
        this.updateEvent.emit();
    }

    switchPage(page) {
        this.page = page;
        this.getVisitorsMeasures();
    }

    delete(visitorMeasure) {
        let self = this;
        let title = this.miscService._t('VISITORS_MEDICAL.DELETE_SETTING') + " ?";
        swal({
            title: title,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: this.miscService._t('SHARED.CONFIRM'),
            cancelButtonText: this.miscService._t('SHARED.CANCEL'),
            closeOnConfirm: true,
            closeOnCancel: true,
        }, function(isConfirm) {
            if(isConfirm) {
                self.visitorMeasureService.delete(visitorMeasure.id).subscribe(data => {
                    self.getVisitorsMeasures(true);  // resets page to 1 (in case of there is only 1 visitor measure on the current page)
                    self.miscService.showMsg({ msg: "VISITOR_SETTING_DELETED", status: "success" });
                    self.updateEvent.emit();
                }, error => {
                    self.miscService.showMsg({ msg: "VISITOR_SETTING_NOT_DELETED" });
                });
            }
        });
    }
}
